module.exports = __webpack_public_path__ + "static/media/nnFood.653653b2.png";